import React,{useState} from 'react'
import "../App.css";
import {Link } from "react-router-dom";
import { FiMenu, FiX } from 'react-icons/fi';

const links=[
  {name:'Home',url:'/'},
  {name:'Products',url:'/Products'},
  {name:'Contact',url:'/contact'},
]

export default function Navbar() {
  const [open, setOpen] = useState(false);

	const handleClick = () => {
		setOpen(!open);
	};

	const closeMenu = () => {
		setOpen(false);
	};
  return (
    
    <>
   
    
    <div  className="bg-slate-700  text-white h-10" >
      
    <div onClick={handleClick} className="nav-icon">
				{open ? <FiX /> : <FiMenu />}
			</div>
      <Link className='kurd-shoes' to={'/'}>{'Kurd Shoes'}</Link>
          <ul className={ open? 'nav-links active ' : 'nav-links'} > 
      {
        
      links.map((link) => {


        return(  
           <li className='nav-item'>
            <Link  to={link.url} onClick={closeMenu} >{link.name}</Link>
           </li>
       ) }
       
       )
      }
      </ul>
      
      </div>
      
      </>
  )
}
